export default __webpack_public_path__ + "static/media/rect_shape.043e5db6.svg";